import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { FormikWysiwygField } from '../../../../Formik'
import { REQUEST_FORM_FIELD_NAME_DESCRIPTION } from '../../RequestForm.constants'

import * as styles from '../RequestFormFields.module.css'

function DescriptionField({ requiredFields, ...restProps }) {
  const { t } = useTranslation()
  const { errors } = useFormikContext()

  return (
    <FormikWysiwygField
      {...restProps}
      enablePasteAutolink
      enableTables
      error={errors[REQUEST_FORM_FIELD_NAME_DESCRIPTION]}
      fieldComponentProps={{
        label: `${t('Request.DescriptionLabelKey')}:`,
        required: requiredFields.includes(REQUEST_FORM_FIELD_NAME_DESCRIPTION),
        shouldAdaptToMobileScreen: true,
      }}
      name={REQUEST_FORM_FIELD_NAME_DESCRIPTION}
      placeholder={t('Request.DescriptionPlaceholderKey')}
      wrapperClassName={styles.fieldWrapper}
    />
  )
}

export default DescriptionField
